export const YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_FAILURE =
  'YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_FAILURE';
export const YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_LIST_SUCCESS =
  'YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_LIST_SUCCESS';
export const YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_LIST_FAILURE =
  'YUSA_OVERNIGHT_CAMP_PROGRAM_AND_PROPERTY_LIST_FAILURE';
